<template>
  <div class="method body-1 pl-16 pr-16">

    <v-container fluid >



      <v-row>
        <v-col
            cols="12"
            lg="8"
            md="8"
            sm="12"
            xl="8"
            class="pl-16 pr-16"
        >
          <v-card>
            <p class="text-h5">Method</p>
          </v-card>
          <p>To generate the results presented in this web app the following datasources/services are used:</p>
          <v-simple-table dense>
            <thead>
            <tr>
              <th class="text-left">
                Purpose
              </th>
              <th class="text-left">
                Datasource              </th>
            </tr>
            </thead>
            <tbody>
            <tr
            >
              <td>Healthcare facilities

              </td>
              <td><a href="https://www.openstreetmap.org/">OpenStreetMap</a></td></tr>
              <tr><td>Accessibility</td>
              <td><a href="https://openrouteservice.org/">openrouteservice</a></td>
              </tr>
            <tr>
              <td>
                Administrative boundaries
              </td>
              <td>
                <a href="https://www.geoboundaries.org/">geoboundaries</a>
              </td>
            </tr>
            <tr>
              <td>
                Population estimates
              </td>
              <td>
                <a href="https://www.worldpop.org/">WorldPop</a>
              </td>
            </tr>
            </tbody>
          </v-simple-table>




          <v-card><p class="text-h6 pt-5">Procedure</p></v-card>

          <p> Areas that can potentially be reached by motorized travel are created using the isochrone service of the
            openrouteservice. An isochrone basically represents an area that is reachable from location <i>x</i> in time
            <i>y</i> by means of transport <i>z</i>. Isochrones are based on principles of (road) network analysis.
            The interaction of facilities, road network, isochrones and population distribution is depicted in the figure on the right. </p>

          <p> Isochrones are calculated for distinct time intervals of 10 minutes each, up to a maximum of 60 minutes.
            In addition, a further interval of greater than 60 minutes to the respective country border is created. For
            each interval, the respective population residing therein is added from WorldPop and then aggregated to
            different scales.
          </p>

          <p>
            [Germany only atm.] For estimates of accessibility to COVID-19 vaccination sites, only travel within state boundaries is considered. This is to comply with current regulations that require residents of a state to go to a vaccination center in that state.
          </p>

          <p>The results are aggregated on different scales: </p>
          <v-list dense>
            <v-list-item>
              1. Country
            </v-list-item>
            <v-list-item>
              2. First admin level (State, district)
            </v-list-item>
            <v-list-item>
              3. Second admin level (district, province) [some countries only]
            </v-list-item>
              <v-list-item>
              4. Hexagons (ISEA3H, zoom level 8)
              </v-list-item>
          </v-list>

          <p> The isochrones are based on two different types of healthcare facilities derived from OpenStreetMap.
            Please see the table below for more details on which objects exactly.</p>

<v-card>
  <p class="text-h6"> OpenStreetMap & healthcare</p></v-card>

          <p>OpenStreetMap holds great potential for free and open healthcare infrastructure data. It has global
          coverage and is easily accessible. In addition, it is user-driven and constantly being updated and expanded.
            For more information on OpenStreetMap in public health, see <a href="https://healthsites.io/">healthsites.io</a>
            and <a href="https://wiki.openstreetmap.org/wiki/Healthcare"> wiki.openstreetmap.org/wiki/Healthcare</a>.</p>


          Here is a list of all healthcare related tags used in this application:



          <v-simple-table>
            <thead>
            <tr>
              <th class="text-left">
                Facility Type
              </th>
              <th class="text-left">
                Relevant Tags              </th>
              <th class="text-left">
                Description
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
            >
              <td>Primary care</td>
              <td><p class="codefont">{amenity,healthcare}=doctors<br/>
              {amenity,healthcare}=clinic<br/>
              healthcare=midwife<br/>
              healthcare=nurse
              healthcare=center
              amenity=health_post<br/></p>
              </td>
              <td>Provision of ambulant, preventive care as well as monitoring and check-ups. E.g. health centers, general practitioners and clinics.</td>
            </tr>
            <tr
            >
              <td>Secondary and tertiary care</td>
              <td><p class="codefont">amenity=hospital or healthcare=hospital</p></td>
              <td> Provison of inpatient care.</td>
            </tr>
            <tr>
              <td>
                COVID-19 Vaccination Centers
              </td>
              <td>
                <p class="codefont" >vaccination=covid19</p>
              </td>
              <td>
                (Temporary) medical facilities for mass vaccination against COVID-19
              </td>
            </tr>
            </tbody>

          </v-simple-table>
        </v-col>
        <v-col
            cols="12"
            lg="4"
            md="4"
            sm="12"
            xl="4"
        >
          <div align="center">


          <img :style="{'width':$vuetify.breakpoint.mdAndUp ? '400px' : '250px'}"

               class="logo-over"
               src="@/assets/img/Isochrone_scheme.svg"
          />
          <p class="caption">Schematic overview of the different main data layers used to produce the results of
            the Open Healthcare Access Map.</p>
          </div>

        </v-col>
      </v-row>

    </v-container>


  </div>
</template>

<script>
export default {
  name: "Method"
};
</script>

<style scoped>
.method {
  height: calc(100% - 36px);
  overflow: auto;
}

a {
  text-decoration: none;
}

.v-application a {
  color: #861801;
}

.codefont {
  font-family:'Lucida Console', monospace;
  background-color: #888888;
  color: azure;
}
</style>
